<script setup>
useHead({
  htmlAttrs: {
    class: "layout-auth",
  },
});
</script>

<template>
  <div class="auth">
    <div class="inner">
      <AuthHeader></AuthHeader>
      <AuthBody>
        <slot />
      </AuthBody>
      <AuthFooter></AuthFooter>
    </div>
  </div>
</template>

<style lang="scss">
html.layout-auth {
  background-color: var(--auth-body-background-color);
  color: var(--auth-body-text-color);
}

html.layout-auth a {
  color: var(--auth-body-text-color);
  text-decoration: none;
}
</style>

<style lang="scss" scoped>
.auth {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100dvh;
  gap: 1rem;
  text-align: center;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.inner {
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 90vw;
  max-width: 400px;
  height: 100%;
  padding: env(safe-area-inset-top) env(safe-area-inset-right) 0
    env(safe-area-inset-left);
  // Cancels out on native once the keyboard is open, since #__nuxt is
  // already sized to end right at the keyboard's top edge (see
  // plugins/keyboardInset.client.ts) and this inset doesn't shrink away on
  // its own in that case. --keyboard-height is unset on web, so this is a
  // no-op there.
  padding-bottom: max(
    0px,
    calc(env(safe-area-inset-bottom, 0px) - var(--keyboard-height, 0px))
  );
}
</style>
